import './Product.scss';
import Component from './Product.js';
export default Component;
